import { ShyScrollbarCss } from '@cycle-app/ui';
import { TabPanels as ReachTabPanels } from '@reach/tabs';
import styled from 'styled-components';

export const TabPanels = styled(ReachTabPanels)`
  ${ShyScrollbarCss};
`;
